import { Badge, Caption1, Caption1Stronger, makeStyles, tokens } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import { formatBraveTooltipDateTime } from '../../utils/dateFormat'

const useStyles = makeStyles({
  versionWrapper: {
    marginTop: tokens.spacingVerticalXS,
    marginBottom: tokens.spacingVerticalS,
  },
})

interface FileCardTooltipContentProps {
  name: string
  version?: string
  createdAt?: string
  updatedAt?: string
}

const FileCardTooltipContent = ({
  name,
  version,
  createdAt,
  updatedAt,
}: FileCardTooltipContentProps) => {
  const styles = useStyles()
  const { t, i18n } = useTranslation()

  // brave file
  if (version && createdAt) {
    return (
      <>
        <Caption1Stronger as="p">{name}</Caption1Stronger>
        <div className={styles.versionWrapper}>
          <Caption1 as="p">{t('brave.documentVersion')} </Caption1>
          <Badge size="small" shape="rounded">
            {version}
          </Badge>
        </div>
        <Caption1 as="p">
          {t('brave.created')} {formatBraveTooltipDateTime(createdAt, i18n.language)}
        </Caption1>
        {updatedAt ? (
          <div>
            <Caption1 as="p">
              {t('brave.lastModified')} {formatBraveTooltipDateTime(updatedAt, i18n.language)}
            </Caption1>
          </div>
        ) : null}
      </>
    )
  }
  // filepool file or brave folders
  return <Caption1Stronger as="p">{name}</Caption1Stronger>
}

export { FileCardTooltipContent }
